<template>
    <div>
        <div v-if="size == 'min'">
            <img class="h-4 w-4 rounded-full" :src="avatar || '/imgs/avatar.jpg'" alt="" @error="handleError" />
        </div>
        <div v-if="size == 'xxs'">
            <img class="h-5 w-5 rounded-full" :src="avatar || '/imgs/avatar.jpg'" alt="" @error="handleError" />
        </div>
        <div v-if="size == 'xs'">
            <img class="h-6 w-6 rounded-full" :src="avatar || '/imgs/avatar.jpg'" alt="" @error="handleError" />
        </div>
        <div v-if="size == 'sm'">
            <img class="h-8 w-8 rounded-full" :src="avatar || '/imgs/avatar.jpg'" alt="" @error="handleError" />
        </div>
        <div v-if="size == 'md'">
            <img class="h-10 w-10 rounded-full" :src="avatar || '/imgs/avatar.jpg'" alt="" @error="handleError" />
        </div>
        <div v-if="size == 'lg'">
            <img class="h-12 w-12 rounded-full" :src="avatar || '/imgs/avatar.jpg'" alt="" @error="handleError" />
        </div>
        <div v-if="size == 'xl'">
            <img class="h-16 w-16 rounded-full" :src="avatar || '/imgs/avatar.jpg'" alt="" @error="handleError" />
        </div>
        <div v-if="size == '2xl'">
            <img class="h-[70px] w-[70px] rounded-full" :src="avatar || '/imgs/avatar.jpg'" alt="" @error="handleError" />
        </div>
    </div>
</template>

<script>
export default {
    name: "Avatar",
    props: {
        avatar: {
            type: String,
            default: '/imgs/avatar.jpg',
        },
        size: {
            type: String,
            default: 'xs',
        },
    },
    methods: {
        handleError(event) {
            event.target.src = '/imgs/avatar.jpg'; // Define a imagem padrão caso ocorra um erro ao carregar a imagem especificada
        },
    },
}
</script>
